/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */
import { type ForgeConnectorProductKey } from '../types/schemas/types';
import { type ProductKeys3P as ProductKeys3PType } from '../ui/configs/types';
// oxlint-disable typescript-eslint(consistent-type-imports)
// oxlint-disable-next-line typescript/consistent-type-imports
import { PrimaryProductKeys } from './primary-product-keys';
// oxlint-disable typescript-eslint(consistent-type-imports)
// oxlint-disable-next-line typescript/consistent-type-imports
import { SearchExperience } from './search-experience';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { PrimaryProductKeys } from './primary-product-keys';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { SearchExperience } from './search-experience';

/**
 * 1P Product keys for Atlassian first-party products.
 */
// oxlint-disable-next-line eslint/no-redeclare
export const ProductKeys1P = {
	Atlas: 'townsquare',
	Bitbucket: 'bitbucket',
	Compass: 'compass',
	Confluence: 'confluence',
	Jira: 'jira',
	JiraProductDiscovery: 'jira-product-discovery',
	JiraServiceManagement: 'jira-servicedesk',
	Trello: 'trello',
	Focus: 'mercury',
	Assets: 'cmdb',
	Talent: 'radar',
} as const;

/**
 * 1P Product keys from ari's are lowercase so we can't use above
 */
export const ARI_EXTRACTED_1P_KEYS: ProductKeys1P[] = Object.values(ProductKeys1P);

export type ProductKeys1P = (typeof ProductKeys1P)[keyof typeof ProductKeys1P];

/**
 * All product keys - combination of 1P and 3P.
 * Note: 3P ProductKeys are re-exported from ui/configs/types.
 */
export type ProductKeys = ProductKeys1P | ProductKeys3PType | ForgeConnectorProductKey;

export type PrimaryProductKey = (typeof PrimaryProductKeys)[keyof typeof PrimaryProductKeys];

/**
 * Noun keys for Atlas nouns (goals, projects, etc.)
 */
// oxlint-disable-next-line eslint/no-redeclare
export const NounKeys = {
	project: 'project',
	goal: 'goal',
	AtlassianWebCrawler: 'atlassian-web-crawler',
} as const;

export type NounKeys = (typeof NounKeys)[keyof typeof NounKeys];

/**
 * Type guard to check if a key is a noun key.
 */
export const isNounKey = (key: string): key is NounKeys => {
	return Object.values(NounKeys).includes(key as NounKeys);
};

export type SearchStoreExperience = (typeof SearchExperience)[keyof typeof SearchExperience];

/**
 * User details types.
 */
export type UserDetails = {
	id: string | null;
	name: string | null;
	email?: string | null;
};

export type UserDetailsWithPicture = UserDetails & {
	picture?: string | null;
};
